import { jwtDecode } from 'jwt-decode';
import tenantConstants from '@constants';
import store from '@store';
import { getItem, setItem } from './localStorageControl';

export const mapUserFromIdToken = (token) => {
  if (token) {
    const kcUser = jwtDecode(token);
    return {
      is_package_user: !!kcUser.realm_roles.find((e) => e === 'profolio-package-user'),
      is_host_user: !!kcUser.realm_roles.find((e) => e === 'profolio-host-user'),
      isCurrencyUser: tenantConstants.IS_CURRENCY_USER,
    };
  }
  return;
};

// `realm_roles` lives in the Keycloak ID token. @bayut-sa/header gates the
// Profolio / TruValue / Host Dashboard / Investors Hub entries of its profile
// dropdown on the roles it gets via `user.realmRoles`, so surface them here.
// Defensive: a missing/unparsable token or a non-array claim yields null, which
// the header treats the same as "no extra entries".
export const getRealmRolesFromIdToken = (token) => {
  if (!token) return null;
  try {
    const realmRoles = jwtDecode(token)?.realm_roles;
    return Array.isArray(realmRoles) ? realmRoles : null;
  } catch (err) {
    return null;
  }
};

export const isUnifiedProfolioEnabled = ({ featureKey } = {}) => {
  const identity = store.getState()?.app?.loginUser?.user;
  if (!featureKey) return false;
  if (!tenantConstants?.UNIFIED_PROFOLIO?.[featureKey]) return false;
  if (!identity?.is_package_user) return false;
  if (identity?.unified === false) return false;
  return true;
};

export const isUnifiedProfolioLiteEnabled = ({ featureKey } = {}) => {
  if (!featureKey) return false;
  if (!tenantConstants?.UNIFIED_PROFOLIO?.[featureKey]) return false;
  return true;
};


export const setBadgeLocalStorage = (user) => {
  if (!user?.id) return;

  const badges = [
    {
      hasBadge: user?.is_quality_lister,
      key: `qualityListerShown_${user.id}`,
    },
    {
      hasBadge: user?.is_responsive_broker,
      key: `responsiveBrokerShown_${user.id}`,
    },
    {
      hasBadge: user?.is_super_lister,
      key: `superListerShown_${user.id}`,
    },
  ];

  badges.forEach((badge) => {
    if (!badge.hasBadge) {
      localStorage.setItem(badge.key, JSON.stringify(false));
    }
  });
};

const truLeadsRowsPerPageKey = (userId) => `truleads_rows_per_page_${userId}`;

// TruLeads rows-per-page (LEG/86eytgf2v): per-user, same-browser-only preference.
// `allowed` is the tenant's option list, so a value outside it (or a corrupt/missing
// entry) always falls back, covering AC#4.
export const getTruLeadsRowsPerPage = (userId, allowed = [], fallback) => {
  if (!userId) return fallback;
  try {
    const stored = getItem(truLeadsRowsPerPageKey(userId));
    return allowed.includes(stored) ? stored : fallback;
  } catch (err) {
    return fallback;
  }
};

export const setTruLeadsRowsPerPage = (userId, value) => {
  if (!userId) return;
  try {
    setItem(truLeadsRowsPerPageKey(userId), value);
  } catch (err) {
    // Storage unavailable (private mode/quota) — selection still applies for the
    // current session and is retried on the next change; no error is shown.
  }
};
